export enum VergleichspaareSortierung {
  NachLohndifferenz,
  NachFunktionswertdifferenz,
  NachKonstellationen,
  NachVergleichsperson,
  NachFunktionen,
  NachGeschlecht
}

export function mapToSortierung(key: string): VergleichspaareSortierung {
  switch (key) {
    case 'sortiertNachLohndifferenz':
      return VergleichspaareSortierung.NachLohndifferenz;
    case 'sortiertNachFunktionswertdifferenz':
      return VergleichspaareSortierung.NachFunktionswertdifferenz;
    case 'sortiertNachKonstellationen':
      return VergleichspaareSortierung.NachKonstellationen;
    case 'sortiertNachVergleichsperson':
      return VergleichspaareSortierung.NachVergleichsperson;
    case 'sortiertNachFunktionen':
      return VergleichspaareSortierung.NachFunktionen;
    case 'sortiertNachGeschlecht':
      return VergleichspaareSortierung.NachGeschlecht;
    default:
      return null;
  }
}
